const AlertPreference = () =>{
    return(
        <>
        </>
    );
}

export default AlertPreference;